export default "__VITE_ASSET__7d2e2bc9__"